import i18n from '@/lang/i18n'
import { ConfigurationTopographicSubsetLaboratoryResponse } from '@/modules/configurationModule/detail/local-samples/topographic-subset-laboratory/services/topographic-subset-laboratory.dto'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ColDef } from '@ag-grid-community/core'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { topographicSubsetLaboratoriesConfigurationServices } from '@/modules/configurationModule/detail/local-samples/topographic-subset-laboratory/services/topographic-subset-laboratory.service'
import { store } from '@/store/store'

export const columnsDefTextTopographicSubsetLaboratoryGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.topography'),
            field: 'topographicCode.description',
            minWidth: 400,
            flex: 2
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            flex: 1,
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface TopographicSubsetLaboratoryGridState extends CrudModelPaginatorLaboratory<ConfigurationTopographicSubsetLaboratoryResponse> {
    labId: number
}
export const initialTopographicSubsetLaboratoryGridState =
    (): TopographicSubsetLaboratoryGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.localSamples.topographicSubsetLaboratory',
        columnsDef: columnsDefTextTopographicSubsetLaboratoryGrid(),
        datasource: new PaginatorLaboratoryDatasource(topographicSubsetLaboratoriesConfigurationServices, store.getters.labId),
        labId: store.getters.labId
    })
